export default __webpack_public_path__ + "static/img-person-02-0a0dbc92dd203644c78b4a1537f27e41.png";